module.exports = __webpack_public_path__ + "img/sky-space-dark-galaxy-2150.a37e1820.jpg";